module.exports = __webpack_public_path__ + "img/product-ketang-jbg-09.5693edbb.png";